// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Vkwa","approved":"Status_approved__3ziJd","rejected":"Status_rejected__2a2D_","expired":"Status_expired__3ruLo","label":"Status_label__3QJ2f"};